import { email, is, pipe, regex, string } from 'valibot'

const schema = pipe(
  string(),
  email(),
  regex(/@(?:universitetsforlaget\.no|juridika\.no|aschehoug\.no)$/i),
)

export function isInternalEmail(email: unknown) {
  return is(schema, email)
}
